import { GlobalState } from '@/redux/store';

export const getArticleRelatedItemIds = (state: GlobalState) => state.articleRelatedItems.itemIds;
